<template>

  <b-card body-class="p-0" header-class="bg-gradient-info border-0 shadow" class="table-card">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0 text-white">
            <i class="ni ni-chart-bar-32 mr-2"></i>Page Analytics
          </h3>
          <p class="text-white-50 mb-0 small">Traffic insights and performance</p>
        </b-col>
        <b-col class="text-right">
          <b-button size="sm" variant="light" class="shadow-sm">
            <i class="ni ni-bold-right mr-1"></i>View Details
          </b-button>
        </b-col>
      </b-row>
    </template>

    <div class="table-container">
      <el-table class="table-responsive table table-hover"
                :data="tableData"
                header-row-class-name="thead-light"
                :row-class-name="tableRowClassName">
        <el-table-column label="Page" min-width="140px" prop="page">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <div class="page-icon mr-3">
                <i class="ni ni-world text-primary"></i>
              </div>
              <div>
                <div class="font-weight-600 text-dark">{{row.page}}</div>
                <small class="text-muted">Web page</small>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Visitors" min-width="100px" prop="visitors">
          <template v-slot="{row}">
            <span class="badge badge-pill badge-primary font-weight-600">{{row.visitors}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Unique" min-width="100px" prop="unique">
          <template v-slot="{row}">
            <span class="badge badge-pill badge-success font-weight-600">{{row.unique}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Bounce Rate" min-width="120px" prop="bounceRate">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <span class="font-weight-600 mr-2">{{row.bounceRate}}</span>
              <b-progress :value="parseFloat(row.bounceRate)" height="6px" class="flex-fill">
                <b-progress-bar :value="parseFloat(row.bounceRate)"
                               :variant="getBounceRateColor(parseFloat(row.bounceRate))">
                </b-progress-bar>
              </b-progress>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </b-card>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  export default {
    name: 'page-visits-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        tableData: [
          {
            page: '/dashboard',
            visitors: '4,569',
            unique: '340',
            bounceRate: '46.53'
          },
          {
            page: '/music',
            visitors: '3,985',
            unique: '319',
            bounceRate: '46.53'
          },
          {
            page: '/videos',
            visitors: '3,513',
            unique: '294',
            bounceRate: '36.49'
          },
          {
            page: '/profile',
            visitors: '2,050',
            unique: '147',
            bounceRate: '50.87'
          },
          {
            page: '/settings',
            visitors: '1,795',
            unique: '190',
            bounceRate: '46.53'
          }
        ]
      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
      },
      getBounceRateColor(rate) {
        if (rate < 40) return 'success';
        if (rate < 50) return 'warning';
        return 'danger';
      }
    }
  }
</script>
<style scoped>
.table-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.table-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
}

.table-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 12px 12px;
  padding: 0;
}

.page-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(94, 114, 228, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-row-even {
  background-color: rgba(0, 0, 0, 0.02);
}

.table-row-odd {
  background-color: rgba(255, 255, 255, 0.8);
}

.table-hover tbody tr:hover {
  background-color: rgba(94, 114, 228, 0.05) !important;
  transform: scale(1.01);
  transition: all 0.2s ease;
}

.badge {
  font-size: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-card:hover {
    transform: none;
  }

  .table-hover tbody tr:hover {
    transform: none;
  }

  .page-icon {
    width: 35px;
    height: 35px;
  }
}
</style>
